import React, { Component } from 'react';
import withRouter from "./components/withRouter"
import Cookies from 'js-cookie';

class Logout extends Component {
  constructor(props) {
    super(props);
    this.hasLoggedOut = false;
  }

  componentDidMount() {
    if (this.hasLoggedOut) return;
    this.hasLoggedOut = true;

    const cookieStr = Cookies.get("userProfile");
    let userType = null;

    if (cookieStr) {
      try {
        const userProfile = JSON.parse(cookieStr);
        userType = userProfile?.types ?? null;
        console.log("userType (before remove):", userType);
      } catch (err) {
        console.error("Failed to parse userProfile cookie:", err);
      }
    } else {
      console.warn("userProfile cookie not found.");
    }

    // เคลียร์ข้อมูล
    localStorage.removeItem('authToken');
    localStorage.removeItem('csrfToken');
    Cookies.remove('sidebarPermit');
    Cookies.remove('userProfile');
    Cookies.remove('XSRF-TOKEN');

    if (userType === null || userType === "" || userType === 4 || userType === "4") {
        setTimeout(() => {
            this.props.navigate('/'); //external-users
        }, 0);
    } else {
        setTimeout(() => {
            this.props.navigate('/back-office'); // back-office
        }, 0);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(Logout);
